import {SectionView} from './SectionView';
import SectionConfiguration from './SectionConfiguration';

export default class FormView {
  constructor(
    readonly selectedSections: SectionView[],
    readonly allSections: SectionView[],
    readonly availableFields: SectionConfiguration[],
  ) {
  }

  translationRequired(): boolean {
    return this.selectedSections.findIndex((value) => value.translationRequired) >= 0;
  }
}
